// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var ReactUtils = require("../../../shared/src/ReactUtils.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Function = require("relude/src/Relude_Function.bs.js");
var BrowserComponents_Spacer = require("./BrowserComponents_Spacer.bs.js");

function element(param_0) {
  return /* Element */{
          _0: param_0
        };
}

function BrowserComponents_SpacedElements(Props) {
  var renderChild = Props.children;
  var elements = Props.elements;
  var keyExtractor = Props.keyExtractor;
  var sizeOpt = Props.spacerSize;
  var size = sizeOpt !== undefined ? sizeOpt : /* Medium */4;
  return React.createElement(ReactUtils.A.make, {
              children: Relude_Array.mapWithIndex((function (param, param$1) {
                      return Relude_Function.curry2((function (param) {
                                    var element = param[0];
                                    if (!element) {
                                      return React.createElement(BrowserComponents_Spacer.make, {
                                                  size: size,
                                                  key: "Spacer" + Relude_Int.toString(param[1])
                                                });
                                    }
                                    var element$1 = element._0;
                                    return React.createElement(React.Fragment, {
                                                children: Curry._1(renderChild, element$1),
                                                key: Curry._2(keyExtractor, element$1, param[1])
                                              });
                                  }), param, param$1);
                    }), Relude_Array.intersperse(/* Spacer */0, Curry._2(Relude_Array.map, element, elements)))
            });
}

var spacer = /* Spacer */0;

var make = BrowserComponents_SpacedElements;

exports.element = element;
exports.spacer = spacer;
exports.make = make;
/* react Not a pure module */
